import { useMutation, useQuery } from "react-query";
import {
  createCompanyPayment,
  updateCompanyPayment,
  getCompanyPaymentDetails,
  getCompanyPaymentProfiles,
  createPaymentProfile,
} from "../api/payment";
import { queryClient } from "./client";

export function useCreateCompanyPayment() {
  return useMutation({
    mutationKey: "createCompanyPayment",
    mutationFn: createCompanyPayment,
    onSuccess: () => {
      queryClient.invalidateQueries("getCompanyPaymentDetails");
      queryClient.refetchQueries("getCompanyPaymentDetails");
    },
    onError: () => {},
  });
}

export function useUpdateCompanyPayment() {
  return useMutation({
    mutationKey: "updateCompanyPayment",
    mutationFn: updateCompanyPayment,
    onSuccess: () => {
      queryClient.invalidateQueries("getCompanyPaymentDetails");
      queryClient.refetchQueries("getCompanyPaymentDetails");
    },
    onError: () => {},
  });
}

export function useGetCompanyPaymentDetails() {
  return useQuery({
    queryKey: "getCompanyPaymentDetails",
    queryFn: getCompanyPaymentDetails,
  });
}

export function useGetCompanyPaymentProfiles() {
  return useQuery({
    queryKey: "getCompanyPaymentProfiles",
    queryFn: getCompanyPaymentProfiles,
  });
}

export function useCreatePaymentProfile() {
  return useMutation({
    mutationKey: "createPaymentProfile",
    mutationFn: createPaymentProfile,
    onSuccess: () => {
      queryClient.invalidateQueries("getCompanyPaymentProfiles");
      queryClient.refetchQueries("getCompanyPaymentProfiles");
    },
    onError: () => {},
  });
}
